function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import Url from "url-parse";
var MAX_DEEPLINK_LENGTH = 4096;
function isValidInboundUrl(url) {
    return url.length <= MAX_DEEPLINK_LENGTH && !/[\u0000-\u001f\u007f]/.test(url) && !/%(?![0-9a-f]{2})/i.test(url);
}
var urlToPathAndParams = function(url) {
    var isWebUrl = url.startsWith('http://') || url.startsWith('https://');
    if (!isWebUrl) url = url.replace('://', ':///');
    var parsedUrl = new Url(url, {}, {
        parser: true
    });
    var query = new Url(url, {}).query;
    var path = parsedUrl.pathname.slice(1);
    return {
        path: path,
        params: parsedUrl.query,
        pathWithQuery: path ? path + query : ''
    };
};
export function parseUrl(url) {
    if (!url || !isValidInboundUrl(url)) return null;
    try {
        var parsedUrl = urlToPathAndParams(url);
        var isAuthDeeplink = !!(parsedUrl.path && parsedUrl.path.startsWith('auth/'));
        return _object_spread_props(_object_spread({}, parsedUrl), {
            isAuthDeeplink: isAuthDeeplink,
            isDeeplink: !!(url !== parsedUrl.path && parsedUrl.path !== '' && url.slice(0, -1) !== parsedUrl.path)
        });
    } catch (e) {
        return null;
    }
}
